import React from 'react'
import Toggle from '../Toggle/Toggle'
import './Navbar.css'
import {Link} from 'react-scroll';
import Logoo from '../../img/logoo.jpg';

const Navbar = () => {
    return (
        <div className="n-wrapper bg">
            <div className="n-left">
                <div className="n-name"><img className='logo' src={Logoo} alt=''
                /></div>
               <Toggle className="toggleButton"/>
            </div>
            <div className="n-right">
                <div className="n-list">
                    <ul style={{listStyleType:'none'}}>
                        <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>  
                        <li className='line1'>Home</li>
                        </Link>
                      
                        <Link spy={true} to='Works' smooth={true} activeClass='activeClass'>  <li className='line2'>Services</li></Link>
                        
                        <Link spy={true} to='Contact' smooth={true} activeClass='activeClass'>  <li className='line2'>Contact information</li></Link>





                    </ul>

                </div>
              {/* <Link spy={true} to='Contact'> <button className="button n-button">Contact</button></Link>  */}


            </div>
        </div>
    )
}
export default Navbar

/*<Link spy={true} to='Portfolio' smooth={true} activeClass='activeClass'>  <li className='line1'>Portfolio         </li></Link>*/